module.exports = __webpack_public_path__ + "img/autospin_btn.5d4695a8.png";